import { render, staticRenderFns } from "./StatementsCreate.vue?vue&type=template&id=26bf6836&scoped=true"
import script from "./StatementsCreate.vue?vue&type=script&lang=js"
export * from "./StatementsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bf6836",
  null
  
)

export default component.exports